// Generated static UI catalog. User-created content is intentionally not included.
module.exports = {
  "Live": "Live",
  "LIVE": "LIVE",
  "Live Preview": "Live Preview",
  "Live versions": "Live versioner",
  "Loading accounts...": "Indl\u00e6ser konti...",
  "Loading editor...": "Indl\u00e6ser editor...",
  "Loading files...": "Indl\u00e6ser filer...",
  "Loading input fields\u2026": "Indl\u00e6ser inputfelter...",
  "Loading logos\u2026": "Indl\u00e6ser logoer...",
  "Loading playbook\u2026": "Indl\u00e6ser afspilningsbogen...",
  "Loading template\u2026": "Indl\u00e6ser skabelon...",
  "Loading templates\u2026": "Indl\u00e6ser skabeloner...",
  "Loading UI page\u2026": "Indl\u00e6ser UI-side...",
  "Loading workflows...": "Indl\u00e6ser workflows...",
  "Loading...": "Indl\u00e6ser...",
  "Loading\u2026": "Indl\u00e6ser...",
  "Locked to source. Click to unlock.": "L\u00e5st til kilden. Klik for at l\u00e5se op.",
  "Log ind for at abne editoren, eller gennemga API-dokumentationen for integration.": "Log ind for at abne editoren, eller gennemga API-dokumentationen for integration.",
  "Login as": "Log ind som",
  "Login as failed.": "Log ind som mislykket.",
  "Login failed.": "Login mislykkedes.",
  "Login first to access the playground.": "Log f\u00f8rst ind for at f\u00e5 adgang til legepladsen.",
  "login is not configured yet.": "login er ikke konfigureret endnu.",
  "login was cancelled.": "login blev annulleret.",
  "login.": "log ind.",
  "Logo URL": "Logo URL",
  "Loop": "L\u00f8kke",
  "Loops": "Sl\u00f8jfer",
  "Lower is faster. Use 0 to jump instantly.": "Lavere er hurtigere. Brug 0 til at hoppe med det samme.",
  "Luk": "Luk",
  "Manage node parameters": "Administrer nodeparametre",
  "Manage your sign-in details. Connected services live under \"Accounts\".": "Administrer dine loginoplysninger. Tilknyttede tjenester lever under \"Konti\".",
  "M\u00e5ned": "M\u00e5ned",
  "Manual": "Manual",
  "marked in red": "markeret med r\u00f8dt",
  "Marker flere knuder med markorvaerkojet og grupper dem med et klik. Gruppen vises som en samlet enhed.": "Marker flere knuder med markorvaerkojet og grupper dem med et klik. Gruppen vises som en samlet enhed.",
  "Max Tokens": "Max Tokens",
  "Mention a workflow": "N\u00e6vn en workflow",
  "Merge": "Flet sammen",
  "Mest brugte knude-typer": "Mest brugte knude-typer",
  "Mest k\u00f8rte workflows": "Mest k\u00f8rte workflows",
  "Microsoft": "Microsoft",
  "Milliseconds": "Millisekunder",
  "Minimize": "Minimer",
  "Minutes": "Referater",
  "Mirror public endpoint runs into this workflow canvas.": "Mirror public endpoint k\u00f8rer ind i dette workflow-l\u00e6rred.",
  "Missing or invalid parameters.": "Manglende eller ugyldige parametre.",
  "Missing page slug.": "Manglende sidesnegl.",
  "Mist": "Mist",
  "Mode": "tilstand",
  "Model Tier": "Model Tier",
  "Model: Fast (Haiku) or Balanced (Sonnet)": "Model: Hurtig (Haiku) eller Balanceret (Sonet)",
  "Monthly": "M\u00e5nedligt",
  "More actions": "Flere handlinger",
  "Most popular": "Mest popul\u00e6re",
  "Move": "Flyt",
  "Move to\u2026": "Flyt til...",
  "Multiline text": "Multiline tekst",
  "Name": "Navn",
  "Name for the workflow. Defaults to \"Untitled\" if omitted.": "Navn p\u00e5 workflowet. Standard er \"Unavngivet\", hvis den udelades.",
  "Nar nogen korer workflowet, vises en formular med alle parametre. Brugeren udfylder felterne og trykker Kor.": "Nar nogen korer workflowet, vises en formular med alle parametre. Brugeren udfylder felterne og trykker Kor.",
  "Natural": "Naturlig",
  "Never": "Aldrig",
  "New flow": "Nyt flow",
  "New flow here": "Nyt flow her",
  "New folder": "Ny mappe",
  "New live version": "Ny live version",
  "New password": "Ny adgangskode",
  "New password must be at least 6 characters.": "Ny adgangskode skal v\u00e6re p\u00e5 mindst 6 tegn.",
  "New password must be different from current password.": "Ny adgangskode skal v\u00e6re forskellig fra den nuv\u00e6rende adgangskode.",
  "New passwords do not match.": "Nye adgangskoder stemmer ikke overens.",
  "New Schedule": "Nyt skema",
  "New template": "Ny skabelon",
  "New user? Sign up": "Ny bruger? Tilmeld dig",
  "New variable": "Ny variabel",
  "NEWER VERSION": "NYERE VERSION",
  "Newest": "Nyeste",
  "Next": "N\u00e6ste",
  "Next Run": "N\u00e6ste l\u00f8b",
  "No": "Nej",
  "No actors found.": "Ingen skuespillere fundet.",
  "No API keys yet.": "Ingen API-n\u00f8gler endnu.",
  "No browser node runs before this one \u2014 a new tab will be opened.": "Ingen browserknude k\u00f8rer f\u00f8r denne - der \u00e5bnes en ny fane.",
  "No editable parameters for this node.": "Ingen redigerbare parametre for denne knude.",
  "No fields.": "Ingen felter.",
  "No files match your search": "Ingen filer matcher din s\u00f8gning",
  "No input schema was found \u2014 provide input as JSON below.": "Der blev ikke fundet noget inputskema - angiv input som JSON nedenfor.",
  "No issues found! Your workflow looks healthy.": "Ingen problemer fundet! Din workflow ser sund ud.",
  "No issues found.": "Ingen problemer fundet.",
  "No items yet.": "Ingen varer endnu.",
  "No knowledge items yet. Add one to keep reusable context organized.": "Ingen vidensartikler endnu. Tilf\u00f8j en for at holde den genanvendelige kontekst organiseret.",
  "No labels": "Ingen etiketter",
  "No learned memory yet. It will build up as you create workflows.": "Ingen l\u00e6rt hukommelse endnu. Det vil bygge op, efterh\u00e5nden som du opretter workflows.",
  "No logos found yet \u2014 add one below.": "Ingen logoer fundet endnu - tilf\u00f8j et nedenfor.",
  "No logos match your search.": "Ingen logoer matcher din s\u00f8gning.",
  "No output fields \u2014 AI will return raw text.": "Ingen outputfelter - AI returnerer r\u00e5 tekst.",
  "No permissions selected": "Ingen tilladelser valgt",
  "No preset nodes saved yet": "Ingen forudindstillede knuder gemt endnu",
  "No previous browser node to continue from \u2014 enter a Webpage URL here so there is a page to pick the element on.": "Ingen tidligere browserknude at forts\u00e6tte fra - indtast en webside-URL her, s\u00e5 der er en side at v\u00e6lge elementet p\u00e5.",
  "No preview to capture yet.": "Ingen forh\u00e5ndsvisning at fange endnu.",
  "No routes": "Ingen ruter",
  "No saved versions yet. They appear here after each save.": "Ingen gemte versioner endnu. De vises her efter hver lagring.",
  "No schedules yet. Create one to automate workflow runs.": "Ingen tidsplaner endnu. Opret en for at automatisere arbejdsgangsk\u00f8rsler.",
  "No selection uses your first connected account.": "Ingen valg bruger din f\u00f8rste tilsluttede konto.",
  "No structured data": "Ingen strukturerede data",
  "No system objects match your search": "Ingen systemobjekter matcher din s\u00f8gning",
  "No tags added yet.": "Ingen tags tilf\u00f8jet endnu.",
  "No templates yet.": "Ingen skabeloner endnu.",
  "No uploaded files yet": "Ingen uploadede filer endnu",
  "No users match.": "Ingen brugere matcher.",
  "No users yet.": "Ingen brugere endnu.",
  "No variables added \u2014 all workflow inputs will be passed.": "Ingen variable tilf\u00f8jet - alle workflow-input vil blive videregivet.",
  "No variables added. The full workflow context is still available.": "Ingen variable tilf\u00f8jet. Den fulde workflow-kontekst er stadig tilg\u00e6ngelig.",
  "No variables available": "Ingen tilg\u00e6ngelige variabler",
  "No variables defined": "Ingen variable defineret",
  "No waitlist entries yet.": "Ingen ventelisteposter endnu.",
  "No workflows in this playbook": "Ingen workflows i denne afspilningsbog",
  "No workflows match this tag.": "Ingen workflows matcher dette tag.",
  "No workflows match your search.": "Ingen workflows matcher din s\u00f8gning.",
  "No workflows yet": "Ingen workflows endnu",
  "No workflows yet. Create your first one.": "Ingen workflows endnu. Opret din f\u00f8rste.",
  "Node": "Knude",
  "Node border color": "Nodekantfarve",
  "Node input": "knude input",
  "Node menu": "knude menu",
  "Node type": "knude type",
  "Node-gruppering": "knude-gruppering",
  "node.fix.applied": "knude.fix.applied",
  "node.fix.retry": "knude.fix.pr\u00f8v igen",
  "Nodes": "Knuder",
  "nodes \u00b7": "knuder \u00b7",
  "Not connected": "Ikke forbundet",
  "Not found": "Ikke fundet",
  "Not now": "Ikke nu",
  "Not published yet": "Ikke offentliggjort endnu",
  "Nothing here yet.": "Intet her endnu.",
  "Notification email": "Meddelelsesmail",
  "Now": "Nu",
  "Nulstil forbrug": "Nulstil forbrug",
  "Nulstiller...": "Nulstiller...",
  "Nulstilles": "Nulstilles",
  "Number": "Nummer",
  "Object": "Objekt",
  "Objects": "Objekter",
  "of your existing node": "af din eksisterende knude",
  "Off": "Fra",
  "Offentlige k\u00f8r-URL'er": "Offentlige k\u00f8r-URL'er",
  "OK": "OK",
  "Olive": "Oliven",
  "On": "P\u00e5",
  "Once": "En gang",
  "One line shown on the store card": "En linje vist p\u00e5 butikskortet",
  "One of the runtime variables is too big to process. Reduce the variable size and try again.": "En af k\u00f8retidsvariablerne er for stor til at behandle. Reducer den variable st\u00f8rrelse og pr\u00f8v igen.",
  "One viewport": "\u00c9t udsigtspunkt",
  "Only approve if this code matches the one shown in your Alleflow extension. The extension receives a revocable workflow token, never your password.": "Godkend kun, hvis denne kode matcher den, der vises i din Alleflow-udvidelse. Udvidelsen modtager et genkaldeligt workflow-token, aldrig din adgangskode.",
  "Open": "\u00c5bn",
  "Open a new tab": "\u00c5bn en ny fane",
  "Open dashboard": "\u00c5bn dashboard",
  "Open in expanded editor": "\u00c5bn i udvidet editor",
  "Open navigation": "\u00c5bn navigation",
  "Open object panel": "\u00c5bn objektpanelet",
  "Open Planner": "\u00c5bn Planner",
  "Open this node in AskCode with the issue pre-loaded": "\u00c5bn denne knude i AskCode med problemet forudindl\u00e6st",
  "Open Workflow Copilot": "\u00c5bn Workflow Copilot",
  "Opening flow\u2026": "\u00c5bner flow...",
  "Opening playbook": "\u00c5bning af spillebog",
  "Opening...": "\u00c5bner...",
  "Opret en gruppe": "Opret en gruppe",
  "Opret et nyt workflow. Send { \"workflowName\": \"Mit flow\" } som JSON body.": "Opret et nyt workflow. Send { \"workflowName\": \"Mit flow\" } som JSON body.",
  "Opret og kor et komplet workflow fra start til slut.": "Opret og kor et komplet workflow fra start til slut.",
  "Optional": "Valgfrit",
  "Optional guidance for the classifier...": "Valgfri vejledning til klassificereren...",
  "OR": "ELLER",
  "or create new": "eller oprette nye",
  "or drag a Start node to begin manually": "eller tr\u00e6k en startknude for at starte manuelt",
  "Organiser komplekse workflows ved at gruppere knuder.": "Organizer komplekse workflows ved at gruppere knuder.",
  "Original Prompt:": "Oprindelig prompt:",
  "Other": "Andet",
  "Other...": "Andet...",
  "Out": "Ud",
  "Outlook": "Outlook",
  "Output": "Output",
  "Output Fields": "Outputfelter",
  "Output Tokens": "Output tokens",
  "Output-format": "Output-format",
  "Overv\u00e5g dit forbrug af kreditter, workflows og AI-ressourcer.": "Overv\u00e5g dit forbrug af kreditter, workflows og AI-ressourcer.",
  "Overview": "Oversigt",
  "Page not available": "Siden er ikke tilg\u00e6ngelig",
  "Parameter": "Parameter",
  "Parameters are read-only in the live version. Switch to Staging to edit them.": "Parametre er skrivebeskyttet i live-versionen. Skift til Staging for at redigere dem.",
  "Parametrene er tilgaengelige som inputs[0] i enhver knude der er forbundet efter Start. F.eks. inputs[0].customerName.": "Parametrene er tilgaengelige som inputs[0] i enhver knude der er forbundet efter Start. F.eks. inputs[0].customerName.",
  "Password": "Adgangskode",
  "Password updated.": "Adgangskode opdateret.",
  "Path parameters": "Sti parametre",
  "Pause": "Pause",
  "Pause execution for a duration": "S\u00e6t udf\u00f8relse p\u00e5 pause i en periode",
  "Paused": "Pause",
  "Peach": "Fersken",
  "pending review": "afventer gennemgang",
  "Periwinkle": "Periwinkle",
  "Permissions": "Tilladelser",
  "Persist": "Vedblive",
  "Persistent": "Vedholdende",
  "Pick a category first": "V\u00e6lg f\u00f8rst en kategori",
  "Pick a node logo": "V\u00e6lg et nodelogo",
  "Pick a source workflow to publish.": "V\u00e6lg en kildearbejdsgang, der skal udgives.",
  "Pick a variable\u2026": "V\u00e6lg en variabel...",
  "Pick another": "V\u00e6lg en anden",
  "Pick at least one workflow before sending.": "V\u00e6lg mindst \u00e9n workflow f\u00f8r afsendelse.",
  "pick date\u2026": "v\u00e6lg dato...",
  "Pick element": "V\u00e6lg element",
  "Pick this step\u2019s element again (single pick, not a re-recording)": "V\u00e6lg dette trins element igen (enkelt valg, ikke en genoptagelse)",
  "Pick which account the planner uses to verify & build.": "V\u00e6lg, hvilken konto planl\u00e6ggeren bruger til at bekr\u00e6fte og bygge.",
  "Pick which account this node uses. Leave unset to use your first connected account.": "V\u00e6lg hvilken konto denne knude bruger. Lad v\u00e6re deaktiveret for at bruge din f\u00f8rste tilsluttede konto.",
  "Pick workflows to use": "V\u00e6lg workflows, der skal bruges",
  "picked actor": "udvalgt skuespiller",
  "Picking\u2026": "V\u00e6lger...",
  "Pixels": "Pixels",
  "Plan a Workflow": "Planl\u00e6g en workflow",
  "Plan ready": "Plan klar",
  "Plan with AI": "Planl\u00e6g med AI",
  "Planer": "H\u00f8vlemaskine",
  "Planlaegning (Scheduler)": "Planl\u00e6gning (Scheduler)",
  "Planner er i tidlig fase": "Planner er i tidlig fase",
  "Planneren kan generere forkerte forbindelser mellem knuder. Gennemga altid det genererede workflow og ret eventuelle connector-fejl for du korer det.": "Planneren kan generere forkerte forbindelser mellem knuder. Gennemga altid det genererede workflow og ret eventuelle connector-fejl for du korer det.",
  "Planning": "Planl\u00e6gning",
  "Play": "Spil",
  "Playbooks": "Playbooks",
  "Please fill in:": "Udfyld venligst:",
  "Please wait...": "Vent venligst...",
  "Popul\u00e6r": "Popul\u00e6r"
};
